import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=297067b9&scoped=true"
import script from "./IconPicker.vue?vue&type=script&lang=js"
export * from "./IconPicker.vue?vue&type=script&lang=js"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=297067b9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297067b9",
  null
  
)

export default component.exports